import React from "react";
import { Route, Routes } from "react-router-dom";
import { routes } from "./index";
import AppLayout from "../Layout/Layout";
import wrapWithProviders from "../utils/wrapWithProviders";
import { RemindersProvider } from "../_helper/Reminders";
import QuickAddProvider from "../_helper/QuickAdd/QuickAddProvider";
import QuickAddFallbacks from "../_helper/QuickAdd/QuickAddFallbacks";
/**
 * Layout-altı route ağacı.
 *
 * KRITIK: Tek parent `<Route element={<LayoutShell />}>` altında 64 child
 * route. Önceki sürüm her path için AYRI parent route tanımlıyordu (64
 * farklı `<Route element={<AppLayout/>}>` instance), bu sayfa geçişinde
 * AppLayout'un her seferinde unmount/mount olmasına neden oluyordu →
 * `TransitionGroup` exit animasyonu yarıda kalıp eski Outlet içeriği
 * DOM'da kalabiliyordu (kullanıcı raporu: "sayfaya tekrar dönünce main
 * alanında duplicate oluşuyor").
 *
 * Tek parent ile: AppLayout sürekli mount; sadece Outlet çocuğu değişir.
 * QuickAdd/Reminders provider'ları yine bir kez mount olur, sayfa
 * geçişinde state'leri korur. Calendar artık feature-scoped — kendi
 * provider'ı (CalendarProvider) yalnızca takvim sayfasında devreye girer.
 */
const LayoutShell = () => (
  <QuickAddProvider>
    <QuickAddFallbacks />
    <RemindersProvider>
      <AppLayout />
    </RemindersProvider>
  </QuickAddProvider>
);

// Inner <Routes> context'inde path absolute olarak yazılsa da v6 leading
// "/" tolere etmiyor — parent path "/*" altında child path'leri relative'e
// çeviriyoruz.
const toRelative = (p = "") => (p.startsWith("/") ? p.slice(1) : p);

const LayoutRoutes = () => (
  <Routes>
    {/* Layout'a path="/*" verildi — pathless layout + index child v6 nested
        <Routes>'ta beklenmedik şekilde match etmiyor. */}
    <Route path="/*" element={<LayoutShell />}>
      {routes.flatMap(({ path, index, Component, providers = [] }) => {
        const Wrapped = wrapWithProviders(Component, providers);
        if (index) {
          return [<Route key="__index" index element={<Wrapped />} />];
        }

        // `:layout` segmenti kaldırıldı — tüm linkler artık temiz URL üretir
        // (örn. /hr). Eski deep-link uyumluluğu için aynı route
        // hem `:layout` ile hem de o segment olmadan kayıt edilir; ikisi
        // de aynı component'e düşer. (Faz: AGENTS.md §11.5 — tamamlandı.)
        const hasLayout = path.endsWith("/:layout");
        const cleanPath = hasLayout ? path.slice(0, -"/:layout".length) : path;
        const out = [
          <Route
            key={path}
            path={toRelative(cleanPath)}
            element={<Wrapped />}
          />,
        ];
        if (hasLayout) {
          out.push(
            <Route
              key={`${path}__legacy`}
              path={toRelative(path)}
              element={<Wrapped />}
            />
          );
        }
        return out;
      })}
    </Route>
  </Routes>
);

export default LayoutRoutes;
